import { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './Terminals.module.scss';
import { useTranslation } from 'react-i18next';

const OpeningHours = memo(({ hours, openingHoursText }) => {
    const { t } = useTranslation();

    if (!hours?.length) {
        return null;
    }

    return (
        <div className={styles.InfoSectionGroup}>
            <h3 className={styles.InfoSectionGroupHeader}>{t('terminals.openingHours')}</h3>
            {hours.map((oh, i) => (
                <div key={`${i}-${oh.text}-${oh.from}-${oh.until}`}>
                    <p>
                        {oh.text}: {oh.from} - {oh.until}
                    </p>
                </div>
            ))}
            {openingHoursText && <p>{openingHoursText}</p>}
        </div>
    );
});

OpeningHours.propTypes = {
    hours: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            from: PropTypes.string,
            until: PropTypes.string,
        })
    ),
    openingHoursText: PropTypes.string,
};

OpeningHours.displayName = 'OpeningHours';

export default OpeningHours;
